// Appointment Status Options (lowercase to match database)
export const appointmentStatusOptions = [
  "scheduled",
  "rescheduled",
  "cancelled",
  "no_show",
] as const;

// Entity Type Options
export const entityTypeOptions = [
  "Lead",
  "User",
  "Customer",
  "Client"
] as const;

// Helper function to format status for display
export const formatStatusLabel = (status: string): string => {
  switch (status) {
    case "no_show": return "No Show";
    case "pending": return "Pending";
    case "scheduled": return "Scheduled";
    case "rescheduled": return "Rescheduled";
    case "confirmed": return "Confirmed";
    case "completed": return "Completed";
    case "cancelled": return "Cancelled";
    case "overdue": return "Overdue";
    default: return status.charAt(0).toUpperCase() + status.slice(1);
  }
};

// Type exports
export type AppointmentStatus = typeof appointmentStatusOptions[number];
export type EntityType = typeof entityTypeOptions[number]; 